var $406532d2625e6ae9$exports = {};
$406532d2625e6ae9$exports = {
    "maximum": `Maksimum`,
    "minimum": `Minimum`
};


export {$406532d2625e6ae9$exports as default};
//# sourceMappingURL=pl-PL.mjs.map
